import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Box, Container } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

const Success = () => {
  return (
    <Container maxWidth="sm" sx={{ pt: 10 }}>
      <Paper
        elevation={12}
        sx={{
          p: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <DoneIcon fontSize="large" color="primary" />
          <Typography variant="h5" align="center">
            Success! Thank you for enrolling!
          </Typography>
        </Box>

        <Typography variant="body1" align="center">
          You will receive an email with the link to access the course.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You may close this page
        </Typography>
      </Paper>
    </Container>
  );
};

export default Success;
